module.exports = __webpack_public_path__ + "img/3f_r_tokyocafe@2x.534b1b0c.png";